import { GameStates } from "onearm";

import { SubGameState } from "./SubGameState";

export class FreespinIdle extends SubGameState {
    enter() {}

    spin() {
        this.gameState.goTo(GameStates.FREE_SPIN_SPINNING);
    }
}
